export default __webpack_public_path__ + "phone_tablet.55e931ca.png";